
    import Vue from 'vue'
    import router from '../router'

    export default Vue.extend({
        name: 'Nav',

        data: () => ({
            bg: "white"

        }),
        mounted() {
            window.onscroll = () => {
                this.changeColor();
            };
        },
        methods: {
            gotoHome() {
                router.push('/').catch(err => {return err})
            },
            changeColor() {
                /*if (
                    document.body.scrollTop > 100 ||
                    document.documentElement.scrollTop > 100
                ) {
                    this.bg = 'rgba(0,0,0,0.7)';
                } else {
                    this.bg = 'rgba(0,0,0,0.3)';
                }*/
            },


        },
        computed: {
            currentRouteName() {
                return this.$route.name;
            }
        }
    })
